<template>
  <div class="section section5">
    <div class="section-con">
      <img
        :src="emptyImage"
        class="fullpage-item-holder"
        style="display: inline;"
      />
      <div class="content-pos">
        <div class="video_h" @click="showVideoPop">
          <span class="video_circle"></span>
          <span class="video_circle2"></span>
          <span class="video_btn"><i></i></span>
          <span class="video_btn_cir"></span>
        </div>
        <div class="swiper-big"></div>
        <div class="mask"></div>
        <div class="swiper-small">
          <swiper
            ref="swiperThumbs"
            :key="swiperVisible"
            class="swiper gallery-thumbs"
            :options="swiperOptionThumbs"
          >
            <swiper-slide
              v-for="(item, index) in videoList"
              :key="index"
              class="slide-1"
              :class="{ active: curInd == index }"
            >
              <div class="small-img">
                <img :src="item.imgSmall" />
                <div class="infor">
                  <span
                    class="play-btn"
                    :data-url="item.videoUrl"
                    :data-ind="index"
                    :data-title="item.title"
                  >
                    play
                  </span>
                  <p class="video-tit">
                    {{ item.title }}
                  </p>
                </div>
              </div>
            </swiper-slide>
          </swiper>
          <div
            slot="button-next"
            class="swiper-button-next swiper-button-white"
          ></div>
          <div
            slot="button-prev"
            class="swiper-button-prev swiper-button-white"
          ></div>
        </div>
        <div></div>
        <video-player :showTitle="showTitle"></video-player>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import VideoPlayer from "@/components/VideoPlayer";
import { getEmptySVG } from "@/libs/svg";
import utils from "@/libs/utils";
const _hmt = window._hmt;
let vm = null;
export default {
  name: "Section5",
  components: {
    VideoPlayer
  },
  data() {
    return {
      curInd: -1,
      videoList: [],
      curPlayVideoUrl: "",
      swiperVisible: false,
      swiperOptionThumbs: {
        loop: true,
        loopedSlides: 5,
        centeredSlides: false,
        slidesPerView: "auto",
        touchRatio: 0.2,
        slideToClickedSlide: false,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev"
        },
        observer: true,
        observeParents: true,
        on: {
          click: function(event) {
            const { title, url, ind } = event.target.dataset;
            if (!title) return;
            vm.showVideo(url, ind, title);
          }
        }
      },
      emptyImage: getEmptySVG(1920, 1080),
      showTitle: true
    };
  },
  computed: {
    ...mapState(["contact"])
  },
  created() {
    vm = this;
  },
  mounted() {
    this.getVideoList();
  },
  methods: {
    ...mapActions(["changeShowVideo", "changeVideoInfor"]),
    changeSrc(url, title) {
      this.curPlayVideoUrl = url;
      this.changeShowVideo(url);
      const videoItem = this.videoList.filter(item => {
        return item.title === title;
      });
      this.changeVideoInfor(videoItem[0]);
    },
    showVideo(url, ind, title) {
      this.changeSrc(url, title);
      this.showVideoPop();
      _hmt.push([
        "_trackEvent",
        "page5",
        "playAudio" + ind,
        utils.checkOperaSys()
      ]);
    },
    showVideoPop() {
      this.changeShowVideo({
        isShow: true,
        src: this.curPlayVideoUrl
      });
    },
    async getVideoList() {
      try {
        const {
          data: { items }
        } = await this.$api.getKMSConfig("media", { f: "data" });
        if (items.length === 0) return;
        const { media } = items[0];
        this.videoList = media.reverse();
        this.curPlayVideoUrl = this.videoList[0].videoUrl;
        this.changeVideoInfor(this.videoList[0]);
        // 重新渲染轮播图
        this.swiperVisible = !this.swiperVisible;
      } catch (error) {
        this.$toast(error?.desc || "Error");
      }
    }
  }
};
</script>
<style lang="less" scoped>
@import "../assets/css/mixin.less";
.section5 {
  position: relative;
  color: #fff;
  background: url("~@/assets/images/bg_05.jpg") no-repeat center top / cover;
  .section-con {
    height: 100% !important;
  }
  .small-img {
    .mixin_com(width, 250);
    .mixin_com(height, 140);
  }
  .video_h {
    position: absolute;
    top: 50%;
    left: 50%;
    .mixin_com(width, 350);
    .mixin_com(height, 350);

    overflow: hidden;
    .transform(translate(-50%, -50%));
  }
  .video_circle,
  .video_circle2 {
    position: absolute;
    top: 50%;
    left: 50%;
    .mixin_com(width, 438);
    .mixin_com(height, 438);
    .mixin_com(margin-top, -219);
    .mixin_com(margin-left, -219);
  }
  .video_circle {
    background:
      url("~@/assets/images/section5/page5_circle.png") no-repeat left
      top / 100%;
    .animation(bl 3s infinite linear);
  }
  .video_circle2 {
    background:
      url("~@/assets/images/section5/page5_circle.png") no-repeat left
      top / 100%;
    .animation(bl 3s 1.5s infinite linear);
  }
  .video_btn {
    position: absolute;
    top: 50%;
    left: 50%;
    .mixin_com(width, 84);
    .mixin_com(height, 84);

    background:
      url("~@/assets/images/section5/play.png") no-repeat left top /
      100%;
    .transform(translate(-50%, -50%));

    i {
      position: absolute;
      top: 50%;
      left: 50%;
      z-index: 3;
      .mixin_com(width, 92);
      .mixin_com(height, 92);
      .mixin_com(margin-top, -46);
      .mixin_com(margin-left, -46);

      cursor: pointer;
      background:
        url("~@/assets/images/section5/playk.png") no-repeat left top /
        100%;
      .animation(tdj_rotate 30s linear infinite);
    }
  }
  .mask {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    .mixin_com(height, 200);

    background-color: rgba(0, 0, 0, 0.7);
  }
  .swiper-small {
    position: absolute;
    left: 50%;
    .mixin_com(bottom, 24);

    z-index: 3;
    .mixin_com(width, 1330);
    .mixin_com(margin-left, -660);
    .gallery-thumbs {
      width: 100%;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .infor {
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      display: flex;
      flex-direction: column;
      align-items: center;
      color: #fff;
      .play-btn {
        display: block;
        .mixin_com(width, 50);
        .mixin_com(height, 50);

        margin: 0 auto;

        .mixin_com(margin-top, 30);

        text-indent: -9999px;
        cursor: pointer;
        background:
          url("~@/assets/images/section5/play2.png") no-repeat center
          top / cover;
        .mixin_transY(-90);

        .transition(0.3s);
      }
      .video-tit,
      .video-txt {
        .mixin_com(width, 240);
        .mixin_com(height, 26);
        .mixin_com(line-height, 26);

        overflow: hidden;
        text-align: center;
        .mixin_transY(90);
        .transition(0.3s);
      }
      .video-tit {
        .mixin_com(font-size, 24);
        .mixin_com(margin-top, 8);
      }
      .video-txt {
        .mixin_com(font-size, 16);
      }
    }
    .swiper-slide {
      position: relative;
      margin-right: 0.16rem !important;
      border: 1px solid #494a4f;
      .mixin_com(width, 252);
      .mixin_com(height, 142);
      &:hover,
      &.active {
        border: 1px solid #acadb0;
        .infor {
          .play-btn,
          .video-tit,
          .video-txt {
            .transform(translateY(0px));
          }
        }
      }
    }
  }
  .swiper-button-prev,
  .swiper-button-next {
    .mixin_com(width, 35);
    .mixin_com(height, 52);
  }
  .swiper-button-prev {
    background:
      url("~@/assets/images/left_arr.png") no-repeat center top /
      cover;
    transform: translateY(-50%);
  }
  .swiper-button-next {
    background:
      url("~@/assets/images/right_arr.png") no-repeat center top /
      cover;
    transform: translateY(-50%);
  }
  .swiper-button-prev,
  .swiper-container-rtl .swiper-button-next {
    .mixin_com(left, -55);
  }
  .swiper-button-next,
  .swiper-container-rtl .swiper-button-prev {
    .mixin_com(right, -55);
  }
  .swiper-button-next::after,
  .swiper-container-rtl .swiper-button-prev::after {
    content: "";
  }
  .swiper-button-prev::after,
  .swiper-container-rtl .swiper-button-next::after {
    content: "";
  }
  .swiper-button-prev.swiper-button-disabled,
  .swiper-button-next.swiper-button-disabled {
    opacity: 1;
  }
}
</style>
